import { fetchOldMarketplaceItemCount } from "@/services/collection";
import { readonly } from "vue";

const count = ref<number>(0);

export function useItemsNeedingAttentionCountStore() {
  const decrement = () => {
    if (count.value > 0) {
      count.value--;
    }
  };

  const fetchCount = async () => {
    count.value = await fetchOldMarketplaceItemCount();
  };

  const clear = () => {
    count.value = 0;
  };

  return {
    count: readonly(count),
    decrement,
    fetchCount,
    clear,
  };
}
